import React, { useState, useEffect } from "react";

import moment from "moment";
import Dialog from "./dialog";
import TimePickerManualEntry from "./timepicker/TimePickerManualEntry";

export default function TimePickerDialog(props) {
  const {
    value,
    isOpen = false,
    onClose = () => {},
    onConfirm = () => {},
    format = null,
  } = props;
  const [selectedTime, setSelectedTime] = useState(null);
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const today = moment().format("YYYY-MM-DD");

  useEffect(() => {
    setIsDialogOpen(isOpen);
    setSelectedTime(value);
  }, [isOpen]);

  const confirmPickerValue = () => {
    if (onConfirm && selectedTime && selectedTime != value) {
      onConfirm(format ? moment(selectedTime).format(format) : selectedTime);
    }

    onClose();
  };

  return (
    <>
      {isDialogOpen ? (
        <Dialog.Container
          onClose={onClose}
          showCloseButton
          headerStyle={{ margin: 0 }}
          contentStyle={{
            paddingTop: 0,
            marginTop: 0,
            paddingBottom: 10,
            paddingHorizontal: 0,
            maxWidth: 383,
          }}
        >
          <TimePickerManualEntry
            startTime={value}
            timeslotDate={today}
            onTimeChanged={(time) => setSelectedTime(time)}
            {...props}
          />
          <Dialog.Button onPress={confirmPickerValue} label="DONE" />
        </Dialog.Container>
      ) : null}
    </>
  );
}
